import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoadingModule } from 'ngx-loading';

import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';

import { AppComponent } from './app.component';
import { HomepageComponent } from './homepage/homepage.component';
import { GameComponent } from './game/game.component';
import { CeiboShare } from 'ng2-social-share';

const appRoutes: Routes = [
  { path: '', component: HomepageComponent },
  { path: 'play', component: GameComponent },
];



@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    GameComponent,
    CeiboShare
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    LoadingModule,
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics])
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.module.ts